"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IntroStatement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15,
    once: true
  });
  return <section id="introstatement" data-nav="light" ref={ref} className="relative bg-background text-foreground py-12 md:py-20 px-6 border-b border-border/40">
      <div className="max-w-4xl mx-auto text-center">
        <div className={`space-y-6 md:space-y-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {/* Eyebrow */}
          <div className="inline-block">
            <span className="text-xs md:text-sm uppercase tracking-widest font-mono text-primary font-semibold">
              Official Innoleaf Website
            </span>
          </div>

          {/* Primary H1 Heading */}
          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight text-foreground leading-[1.18] max-w-3xl mx-auto">
            Innoleaf – Your Travel Partner for Exceptional Holidays
          </h1>

          {/* Lead Paragraph */}
          <p className="text-base sm:text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto font-normal">
            Innoleaf is a travel and holiday brand specializing in customized domestic and international vacations, honeymoon experiences, family holidays, group departures and end-to-end travel arrangements.
          </p>
        </div>
      </div>
    </section>;
}